module.exports = __webpack_public_path__ + "img/pin.f07ebd5a.png";